import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

type PropsType = {
  clinicAccountNumber: string;
  zipCode: string;
};

export const ClinicSection = ({ clinicAccountNumber, zipCode }: PropsType) => {
  const { t } = useTranslation('donor.RoutineTest.ClinicSection');

  return (
    <Col className={styles.clinicSection}>
      <Row align="middle" key="firstRow">
        <Col className={styles.label}>{t('clinicAccount')}:</Col>
        <Col>
          <input
            className={styles.input}
            value={clinicAccountNumber}
            readOnly
          />
        </Col>
        <Col className={styles.label}>{t('zipCode')}:</Col>
        <Col flex="1 1 0px">
          <input className={styles.input} value={zipCode} readOnly />
        </Col>
      </Row>
      <Col key="secondRow">
        <Row align="middle">
          <Col className={styles.label}>{t('hospitalOrClinic')}:</Col>
          <Col flex="auto">
            <input className={styles.input} value="NAVBB" readOnly />
          </Col>
        </Row>
      </Col>
    </Col>
  );
};
